import React from 'react';

interface MobileHeaderProps {
  initials: string;
  name: string;
  onAvatarClick: () => void;
}

export const MobileHeader = ({
  initials,
  name,
  onAvatarClick,
}: MobileHeaderProps) => (
  <header className="tw-flex-none tw-h-[56px] tw-flex tw-items-center tw-gap-[12px] tw-px-[16px] tw-bg-ds-rail tw-bg-cover tw-bg-center tw-relative tw-z-10">
    {/* White icon-only mark from public/images/ */}
    <img
      src="/images/cloudcfo-logo-white-icon-only.png"
      width={26}
      height={26}
      alt="CloudCFO"
    />
    <span className="tw-font-poppins tw-text-[16px] tw-font-semibold tw-text-white tw-tracking-[-0.01em]">
      CloudCFO
    </span>
    {/* tw-border-solid + tw-m-0 counter the global button{border:none;margin-right:8px} reset. */}
    <button
      type="button"
      title={name}
      onClick={onAvatarClick}
      className="tw-ml-auto tw-w-[32px] tw-h-[32px] tw-m-0 tw-p-0 tw-cursor-pointer tw-rounded-full tw-bg-white/[.18] tw-text-white tw-text-[12px] tw-font-semibold tw-inline-flex tw-items-center tw-justify-center tw-font-poppins tw-border-solid tw-border-[1.5px] tw-border-white/[.35]"
    >
      {initials}
    </button>
  </header>
);
